/*
 * File: MainHeader.js
 * Project: mp-mobile-app
 *
 * Created by Dillon Neukirch on 12/20/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Page Header used throughout the app
 */
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  overlineTxt: {
    fontWeight: 500,
    letterSpacing: theme.spacing(0.25),
    color: props =>
      props.clinical ? theme.palette.common.black : theme.palette.secondary.main
  },
  title: {
    textAlign: "left",
    color: props =>
      props.clinical
        ? theme.palette.common.black
        : theme.palette.secondary.dark,
    maxWidth: "80%",
    marginTop: theme.spacing(-0.5),
    marginLeft: theme.spacing(-0.25),
    fontWeight: 400
  }
}));

const MainHeader = ({ pageTitle, pageSubtitle, clinical }) => {
  const classes = useStyles({ clinical: clinical });

  return (
    <React.Fragment>
      <Typography variant="subtitle1" className={classes.overlineTxt}>
        {pageSubtitle}
      </Typography>
      <Typography variant="h4" className={classes.title}>
        {pageTitle}
      </Typography>
    </React.Fragment>
  );
};

MainHeader.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  pageSubtitle: PropTypes.string,
  clinical: PropTypes.bool
};

export default MainHeader;
